export const LEADERBOARDS_TYPE = {
    PERSONAL_PERIODIC: 'PERSONAL_PERIODIC',
    CLAN_PERIODIC: 'CLAN_PERIODIC',
    CLAN: 'CLAN',
}

export const REWARD_TYPE = {
    GOLD: 'GOLD',
    CLAN_BONDS: 'CLAN_BONDS',
    BONDS: 'BONDS',
    MEDAL_ELITE: 'medal_elite',
    MEDAL_FIRST: 'medal_first',
    MEDAL_SECOND: 'medal_second',
    MEDAL_THIRD: 'medal_third',
    MEDAL_VETERAN: 'medal_veteran',
    DECAL: 'decal',
    STYLE: 'style',
    EMBLEM: 'emblem',
}

export const CLIENT_REWARD_TYPE = {
    [REWARD_TYPE.BONDS]: 'custom/crystal',
    [REWARD_TYPE.CLAN_BONDS]: 'custom/crystal',
    [REWARD_TYPE.MEDAL_ELITE]: 'achievement',
    [REWARD_TYPE.MEDAL_FIRST]: 'achievement',
    [REWARD_TYPE.MEDAL_SECOND]: 'achievement',
    [REWARD_TYPE.MEDAL_THIRD]: 'achievement',
    [REWARD_TYPE.MEDAL_VETERAN]: 'achievement',
    [REWARD_TYPE.STYLE]: 'style/all',
    [REWARD_TYPE.DECAL]: 'projection_decal/all',
    [REWARD_TYPE.GOLD]: 'custom/gold',
    [REWARD_TYPE.EMBLEM]: 'decal/1',
}

export const ERROR_ACTION_TYPE = {
    LEADERBOARDS_ERROR: 'LEADERBOARDS_ERROR',
    GET_REWARDS_ERROR: 'GET_REWARDS_ERROR',
}

export const MAX_VISIBLE_REWARD_COUNT = 4
export const LEADERBOARDS_HASH = '#leaderboards'



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/constants.js